import { Serializable, SerializationHelper } from "@/helpers/SerializationHelper";
import { SalesCapacity } from "@/model/product/SalesCapacity";
import { FishingOrigin } from "./FishingOrigin";
import { equals } from "@/helpers/ObjectsHelper";
export class Product implements Serializable {

    productId: string;
    storeId: string;
    cug: string;
    label: string;
    zoneCode: string;
    sectorCode: string;
    sectorLabel: string;
    origin?: string;
    lastOutOfStockDate: Date;
    thumbnail: string;
    weekSales: number;
    weeklyCapacity: SalesCapacity[];
    inStockToday: boolean;
    fishingOrigin?: FishingOrigin;
    isCateringService: boolean = false;

    fromJSON(rawObject: any) {
        SerializationHelper.copyNonExcludedProperties(this, rawObject, ['weeklyCapacity', 'fishingOrigin', 'flags']);
        this.weeklyCapacity = SerializationHelper.toArrayInstanceFromJsonObjArray(() => new SalesCapacity(), rawObject.weeklyCapacity);
        this.fishingOrigin = new FishingOrigin();
        if (rawObject.fishingOrigin) {
            this.fishingOrigin.fromJSON(rawObject.fishingOrigin);
        }
        if (rawObject.flags) {
            this.isCateringService = rawObject.flags.includes('CATERING');
        }
    }

    public equals(that: Product): boolean {
        if (that == null) {
            return false;
        }

        return equals(this, that, (p: Product) => p.productId)
            && equals(this, that, (p: Product) => p.storeId)
            && equals(this, that, (p: Product) => p.cug)
            && equals(this, that, (p: Product) => p.label)
            && equals(this, that, (p: Product) => p.zoneCode)
            && equals(this, that, (p: Product) => p.sectorCode)
            && equals(this, that, (p: Product) => p.sectorLabel)
            && equals(this, that, (p: Product) => p.origin)
            && equals(this, that, (p: Product) => p.lastOutOfStockDate)
            && equals(this, that, (p: Product) => p.thumbnail)
            && equals(this, that, (p: Product) => p.weekSales)
            && this.compareWeeklyCapacity(this.weeklyCapacity, that.weeklyCapacity)
            // inStockToday is transient
            && equals(this, that, (p: Product) => p.fishingOrigin)
            && equals(this, that, (p: Product) => p.isCateringService);
    }

    private compareWeeklyCapacity(p1: SalesCapacity[], p2: SalesCapacity[]): boolean {
        if (p1 === p2) {
            return true;
        }

        if (p1 == null || p2 == null) {
            return false;
        }

        if (p1.length !== p2.length) {
            return false;
        }

        for (let i = 0; i < p1.length; i++) {
            const item1: SalesCapacity = p1[i];
            const item2: SalesCapacity = p2.find(item => item.dayOfWeek === item1.dayOfWeek);

            if (!equals(item1, item2)) {
                return false;
            }
        }

        return true;
    }
}
